import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagMuted = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--muted', className].filter(Boolean).join(' ')} />
);
